/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Start_LabelInputs */

const en_job_form_slot_generation_start_label = /** @type {(inputs: Job_Form_Slot_Generation_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const de_job_form_slot_generation_start_label = /** @type {(inputs: Job_Form_Slot_Generation_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginn`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Job_Form_Slot_Generation_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_start_label = /** @type {((inputs?: Job_Form_Slot_Generation_Start_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Start_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_start_label(inputs)
	return en_job_form_slot_generation_start_label(inputs)
});